/*
 * サブシステム名：請求
 * 機能名：請求明細一覧
 * 表示項目カスタマイズ(光陽テクノサービス)
 */

import D2BILD1020 from '@/views/BIL/D2BILD1020.js'

import filter from '@/rahmen/utils/filters'

export default {
  extends: D2BILD1020,
  name: 'SeikyuMeisaiListEditForKts',
  data: () => ({
  }),
  computed: {
    unsoShokei () {
      let unsoSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiKihonUnchin',
          'meisaiTaikiJikanKingaku',
          'meisaiUserKingakuKazei1',
          'meisaiUserKingakuKazei4',
          'meisaiUserKingakuKazei5',
          'meisaiUserKingakuKazei6',
          'meisaiUserKingakuKazei7',
          'hinmokuKihonUnchin'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            unsoSum += Number(item[f])
          }
        })
      })

      return unsoSum
    },
    unsoShokeiDisp () {
      return filter.numericFormatter(this.unsoShokei)
    },
    sagyoShokei () {
      let kazeiSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiTsumikomiKingaku',
          'meisaiFutaiGyomuKingaku1',
          'meisaiFutaiGyomuKingaku2',
          'meisaiFutaiGyomuKingaku3'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            kazeiSum += Number(item[f])
          }
        })
      })

      return kazeiSum
    },
    sagyoShokeiDisp () {
      // 合計金額の表示
      return filter.numericFormatter(this.sagyoShokei)
    },
    hiwayGokei () {
      let hiwaySum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiHiwayPrice',
          'hinmokuHiwayPrice'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            hiwaySum += Number(item[f])
          }
        })
      })
      return hiwaySum
    },
    hiwayTax () {
      const target = filter.dateFormatter(new Date())
      const tax = this.taxList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
      return this.hiwayGokei * ((tax[0].taxPer / 100) / (1 + tax[0].taxPer / 100))
    },
    taxPrice () {
      const target = filter.dateFormatter(new Date())
      const tax = this.taxList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
      return Math.round(this.allKazeiGokei * (tax[0].taxPer / 100) + this.hiwayTax)
    },
    taxPriceDisp () {
      return filter.numericFormatter(this.taxPrice)
    },
    anzenEiseiKyorokuKaihi () {
      let kaihiSum = 0

      this.rows.forEach(item => {
        const fields = [
          'meisaiUserKingakuKazei10'
        ]

        fields.forEach(f => {
          if (![undefined, null, '0', ''].includes(item[f])) {
            kaihiSum += Number(item[f])
          }
        })
      })

      return kaihiSum
    },
    anzenEiseiKyorokuKaihiDisp () {
      return filter.numericFormatter(this.anzenEiseiKyorokuKaihi)
    },
    allUnchinGokeiDisp () {
      // 合計金額の表示
      return filter.numericFormatter(Math.round(this.unsoShokei + this.sagyoShokei + this.taxPrice + this.hiwayGokei + this.anzenEiseiKyorokuKaihi - this.hiwayTax))
    }
  },
  method: {
  }
}
